import { TextSelection } from "prosemirror-state";

/**
 * 현재 블록 뒤에 2단 컬럼(columnList > column×2 > 빈 단락)을 삽입한다.
 *
 * BlockNote의 editor.insertBlocks는 public blockSchema에 없는 타입(columnList/column)을
 * "unrecognized type"으로 거부하므로, ProseMirror 트랜잭션으로 직접 삽입한다.
 * id는 코어 UniqueID 확장이 누락 노드에 자동 부여한다(types에 columnList/column 포함).
 *
 * @returns 삽입 성공 여부.
 */
export function insertTwoColumns(
  editor: any,
  showDivider: boolean = false,
): boolean {
  const tiptap = editor?._tiptapEditor;
  if (!tiptap) {
    return false;
  }
  const { state, schema } = tiptap;
  const { blockContainer, paragraph, column, columnList } = schema.nodes;
  if (!blockContainer || !paragraph || !column || !columnList) {
    return false;
  }

  const $from = state.selection.$from;

  // 컬럼 중첩 금지: 조상에 column/columnList가 있으면 거부(컬럼 안에 columnList를
  // 넣으면 column content "blockContainer+" 위반 → 삽입이 throw). 안전하게 no-op.
  for (let d = $from.depth; d > 0; d--) {
    const name = $from.node(d).type.name;
    if (name === "column" || name === "columnList") {
      return false;
    }
  }

  // 현재 selection을 감싸는 blockContainer를 찾아 그 뒤(blockGroup 형제 위치)에 삽입.
  let depth = $from.depth;
  while (depth > 0 && $from.node(depth).type.name !== "blockContainer") {
    depth--;
  }
  if (depth === 0) {
    return false;
  }
  const insertPos = $from.after(depth);

  const mkBlock = () => blockContainer.create(null, paragraph.create());
  const mkColumn = () => column.create(null, mkBlock());
  // showDivider는 생성 시 고정(가운데 세로 구분선 유무). id는 UniqueID가 자동 부여.
  const list = columnList.create({ showDivider }, [mkColumn(), mkColumn()]);

  // insert/dispatch는 위치가 어떤 이유로든 무효면 throw할 수 있으므로 가드한다.
  try {
    let tr = state.tr.insert(insertPos, list);
    // 첫 컬럼의 단락으로 커서 이동(columnList+1, column+1, blockContainer+1, paragraph+1).
    try {
      tr = tr.setSelection(TextSelection.create(tr.doc, insertPos + 4));
    } catch {
      // 위치 매핑 실패 시 커서 이동은 생략(삽입 자체는 유효).
    }
    tiptap.view.dispatch(tr.scrollIntoView());
    return true;
  } catch {
    return false;
  }
}
